import type { Distance, Rectangle } from "@pdfking/math"

import type { GrowSize } from "#internal"
import type { OrientationKind } from "#internal"

/** The page as a grow's lengths read it: as it opens at the side — `width`
 * along the opening —, turned when it opens at the top. */
export const GrowSideSize = (
  canvas: Rectangle<Distance>,
  orientation: OrientationKind,
  ctx: Pick<GrowSize, "depth" | "sheet_depth">
): GrowSize =>
  orientation.opening_top
    ? { width: canvas.height, height: canvas.width, ...ctx }
    : { width: canvas.width, height: canvas.height, ...ctx }
